/**
 * Links headline to story (when possible) and expands URL (if necessary)
 * @author Ryan Gladstone, Umer Hassan
 * <story-headline story="story"></story-headline>
 */

const template = `<a ng-show="$ctrl.hasURL" ng-href="{{$ctrl.fullUrl}}" target="_blank">
                    {{::$ctrl.story.websked.headline_clean}}</a>
                  <span ng-hide="$ctrl.hasURL"> {{::$ctrl.story.websked.headline_clean}} </span>`;

class StoryHeadlineController {
  constructor($log, urlConversionService) {
    this.$log = $log;
    this.urlConversionService = urlConversionService;
  }

  $onChanges(changes) {
    this.story = changes.story ? changes.story.currentValue : null;
    if (this.story && this.story.url) {
      this.hasURL = true;
      this.urlConversionService.expandURL(this.story)
        .then((response) => {
          this.fullUrl = response;
        }, (response) => {
          this.$log.error('urlConversionService error: ', response);
        });
    } else {
      // If the story doesn't have a URL, remove `hasURL` flag and constructed URL
      // This is important for story cards, which are reused
      this.hasURL = false;
      this.fullUrl = null;
    }
  }
}

StoryHeadlineController.$inject = ['$log', 'urlConversionService'];

const component = {
  template,
  bindings: {
    story: '<'
  },
  controller: 'StoryHeadlineController'
};

export default function (ngModule) {
  ngModule.component('storyHeadline', component);
  ngModule.controller('StoryHeadlineController', StoryHeadlineController);
}
